import React, { useEffect, useState } from 'react';
import api from '@/services/api';
import { message, Spin, Switch, Input, Row, Col, Typography, Button, Card } from 'antd';
import { ChromePicker } from 'react-color';
import { useDispatch } from 'react-redux';
import { setSiteSettings } from '@/store/settings';

const { Title } = Typography;

const colorKeys = [
  "HeaderBgColor",
  "HeaderTextColor",
  "HeaderIconColor",
  "HeaderBaseBgColor",
  "HeaderBaseIconColor",
  "HeaderBaseTextColor",
  "SearchBackgroundColor",
  "SearchColor"
];

const booleanKeys = [
  "HeaderShowCurrency",
  "HeaderShowLanguage"
];

const ManagementTheme = () => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState({});
  const [showPickers, setShowPickers] = useState({});
  const dispatch = useDispatch();

  const fetchSettings = async () => {
    setLoading(true);
    const query = colorKeys.concat(booleanKeys).join('&');

    try {
      const response = await api()({
        url: '/webshop/management/settings/multiple',
        method: 'GET',
        params: { query }
      });

      const obj = {};
      for (const item of response.data.data) {
        obj[item.Keyword] = item.Value;
      }
      setData(obj);
    } catch (error) {
      message.error('Ayarlar alınırken hata oluştu.');
      console.error('Error fetching settings:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchSettings();
  }, []);

  const handleColorChange = (key, color) => {
    const value = color.hex;
    setData(prev => ({ ...prev, [key]: value }));
    dispatch(setSiteSettings({ type: key, value }));
  };

  const handleSwitchChange = (key, checked) => {
    setData(prev => ({ ...prev, [key]: checked }));
    dispatch(setSiteSettings({ type: key, value: checked ? 'true' : 'false' }));
  };

  const handleInputChange = (key, e) => {
    setData(prev => ({ ...prev, [key]: e.target.value }));
  };

  const togglePicker = (key) => {
    setShowPickers(prev => ({ ...prev, [key]: !prev[key] }));
  };

  const handleReset = async () => {
    setData({});
    setShowPickers({});

    const query = colorKeys.concat(booleanKeys).join('&');

    try {
      const response = await api()({
        url: '/webshop/management/settings/multiple',
        method: 'GET',
        params: { query }
      });

      const obj = {};
      for (const item of response.data.data) {
        obj[item.Keyword] = item.Value;
        dispatch(setSiteSettings({ type: item.Keyword, value: item.Value })); // 🔁 Redux güncelleme
      }

      setData(obj);
      message.info('Ayarlar varsayılan hale getirildi.');
    } catch (error) {
      message.error('Ayarlar sıfırlanırken hata oluştu.');
      console.error('Reset fetch error:', error);
    }
  };


  const handleSave = async () => {
    setLoading(true);
    
    let _data = JSON.parse(JSON.stringify(data)); // Düz object formatında gönderim

   _data['HeaderShowLanguage'] = _data['HeaderShowLanguage'] ? 'true' : 'false';
   _data['HeaderShowCurrency'] = _data['HeaderShowCurrency'] ? 'true' : 'false';

    try {
      await api()({
        url: '/webshop/management/settings',
        method: 'POST',
        data: {
          data: _data // düz object formatında gönderim
        }
      });

      message.success('Ayarlar kaydedildi.');
    } catch (e) {
      message.error('Ayarlar kaydedilirken hata oluştu.');
      console.error(e);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Spin spinning={loading}>
      <Card style={{ padding: 24 }}>
        <Title level={4}>Tema Ayarları</Title>
        <Row gutter={[16, 24]}>
          {Object.keys(data).map(key => {
            if (colorKeys.includes(key)) {
              return (
                <Col span={12} key={key}>
                  <div style={{ marginBottom: 8 }}>{key}</div>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                    <div
                      onClick={() => togglePicker(key)}
                      style={{
                        width: 40,
                        height: 40,
                        backgroundColor: data[key],
                        border: '1px solid #ccc',
                        cursor: 'pointer'
                      }}
                    />
                    <span>{data[key]}</span>
                  </div>
                  {showPickers[key] && (
                    <div style={{ position: 'relative', zIndex: 10, marginTop: 8 }}>
                      <ChromePicker
                        color={data[key]}
                        onChange={color => handleColorChange(key, color)}
                      />
                    </div>
                  )}
                </Col>
              );
            }

            if (booleanKeys.includes(key)) {
              return (
                <Col span={12} key={key}>
                  <div style={{ marginBottom: 8 }}>{key}</div>
                  <Switch
                    checked={data[key] === true || data[key] === 'true'}
                    onChange={checked => handleSwitchChange(key, checked)}
                  />
                </Col>
              );
            }

            return (
              <Col span={12} key={key}>
                <div style={{ marginBottom: 8 }}>{key}</div>
                <Input
                  value={data[key]}
                  onChange={(e) => handleInputChange(key, e)}
                />
              </Col>
            );
          })}
        </Row>

        <div style={{ marginTop: 32 }}>
          <Button type="primary" onClick={handleSave} style={{ marginRight: 16 }}>
            Kaydet
          </Button>
          <Button onClick={handleReset}>Sıfırla</Button>
        </div>
      </Card>
    </Spin>
  );
};

export default ManagementTheme;
